import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import { allowedRoutesWithoutAuth } from '../../config/allowedRoutes'
import { NotificationProvider } from '../../contexts/NotificationContext'
import { useUser } from '../../contexts/UserContext'
import './Dashboard.css'

export default function DashboardPage() {
  const navigate = useNavigate()
  const [logged, setLogged] = useState<boolean>(true)
  const [isContestPage, setIsContestPage] = useState<boolean>(false)
  const { fetchRoles } = useUser()

  useEffect(() => {
    const loadRoles = async () => {
      await fetchRoles()
    }

    if (!localStorage.getItem('token')) {
      setLogged(false)
    } else {
      loadRoles()
    }
  }, [])

  useEffect(() => {
    // Verifica se a rota atual é uma que não deve exibir o header e sidebar (rotas de concurso,
    // etiquetas ou a tela do leilão, que é espelhada num telão)
    if (
      /\/concurso\/[^/]+(?:\/(?:inscricao|envio))?$/.test(window.location.pathname) ||
      /\/contests\/artwork-labels\/[^/]+/.test(window.location.pathname) ||
      /\/events\/[^/]+\/auction-screen$/.test(window.location.pathname)
    ) {
      setIsContestPage(true)
    } else {
      setIsContestPage(false)
    }
  }, [window.location.pathname])

  useEffect(() => {
    // Rotas liberadas mesmo sem estar logado:
    const isAllowedRoute = allowedRoutesWithoutAuth.some((route) => route.test(window.location.pathname))

    if (!logged && !isAllowedRoute) {
      // Preserve deep links (e.g. kanban card links in e-mails) so the login page can redirect back.
      sessionStorage.setItem('redirect_after_login', window.location.pathname + window.location.search)
      navigate('/login')
    }
  }, [logged, navigate])

  const hasSidebar = logged && !isContestPage

  const content = (
    <>
      {hasSidebar && (
        <>
          <Sidebar />
          <Header />
        </>
      )}
      <div className={`dashboard-content${hasSidebar ? '' : ' dashboard-content--no-sidebar'}`}>
        <Outlet />
      </div>
    </>
  )

  return logged ? <NotificationProvider>{content}</NotificationProvider> : content
}
